import { Component, forwardRef, Input } from "@angular/core";
import { NG_VALUE_ACCESSOR, RadioControlValueAccessor } from "@angular/forms";

const INPUT_CONTROL_ACCESSOR = {
	provide: NG_VALUE_ACCESSOR,
	useExisting: forwardRef(() => RadioComponent),
	multi: true,
};

@Component({
	selector: "pv-radio",
	styleUrls: ["input.component.scss"],
	providers: [INPUT_CONTROL_ACCESSOR],
	templateUrl: "./input.component.html",
	standalone: false,
})
export class RadioComponent extends RadioControlValueAccessor {
	@Input() label: string;
	@Input() inputClass = "";
	@Input() error = false;
	@Input() help: string;
	@Input() value: string | boolean = "";

	disabled = false;
	selected = false;

	setDisabledState(isDisabled: boolean) {
		this.disabled = isDisabled;
	}

	select() {
		this.selected = true;
		this.onChange();
		this.onTouched();
	}

	writeValue(value: any) {
		this.selected = value === this.value;
		super.writeValue(value);
	}
}
